 /**
 *    @author: Andrew Sheen
 *    @since:  2021-02-06
 */

import { Component, ViewEncapsulation, ElementRef, OnInit, OnDestroy,AfterViewInit } from '@angular/core';
import { CommonService } from 'src/refresh/service/common-service';
import { LayoutBaseComponent } from '../layout-base.component';

@Component({
  selector: 'light-box',
  templateUrl: './light-box.component.html',
  styleUrls: ['./light-box.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class LightBox extends LayoutBaseComponent  implements OnInit,OnDestroy,AfterViewInit {

      static currentBox:LightBox;
      public static closeBox() {
             if ( LightBox.currentBox ) LightBox.currentBox.close();
      }

      private element: any;
      private rootDiv:any;
      constructor(private el: ElementRef,
            private commonService: CommonService) {
            super(); 
            this.element = el.nativeElement;
      }

      public get className():string {
             return "_lightbox main-width center "+this.class_name;
      }

      public get inputClass():string {
             return "box-body "+ this.input_class;
      }

      public get labelClass():string {
            return this.label_class;
      }


      public ngOnInit(): void {
             document.body.appendChild(this.element);

             this.element.addEventListener('click', el => {

                  if ( "LIGHT-BOX"  != el.target.parentElement.nodeName ) return;
                  this.commonService.closeLightBox();
                  el.stopPropagation();
                  el.preventDefault();
             });
 
      }

      public ngAfterViewInit() {
            let div = this.element.querySelector('div');
            super.layoutFromViewInit(div);

            div = div.querySelector('div');

            this.rootDiv = div.querySelector('div');
     }       

      public ngOnDestroy() {
             ////this.element.remove();
      }

      public open() {
             this.element.style.display = 'block';
             document.body.classList.add('box-open');
             this.rootDiv.classList.add('remove-focus');
             this.rootDiv.focus();

             LightBox.currentBox = this;
      }

      public close()  {
             this.element.style.display = 'none';
             document.body.classList.remove('box-open');
      }

      public tabMenu(event){
            if(!event.target.contains(event.relatedTarget)){
               this.rootDiv.focus();
            }
      }

      public tabMenuRootDiv(){
            this.rootDiv.focus();
      }
}
